/* eslint-disable no-magic-numbers */
import { CUSTOMER_SUPPLIER_KIND } from '../../forecast/detail/performance/customers-and-suppliers/const';
import { Data, FILTER_TYPE, TableFilters, TableFiltersState, TABLE_COLUMN } from '../table-filters/filter-table-types';

export const mockedInitialFilters: TableFilters = {
  [TABLE_COLUMN.TYPE]: {
    filterType: FILTER_TYPE.SELECT
  },
  [TABLE_COLUMN.CONTACT]: {
    filterType: FILTER_TYPE.TEXT
  },
  [TABLE_COLUMN.TOTAL_DUE]: {
    filterType: FILTER_TYPE.NUMBER
  },
  [TABLE_COLUMN.TOTAL_OVERDUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.TOTAL_INVOICED]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.INVOICES_DUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.TOTAL_DUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.AVERAGE_SALE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.DAYS_TO_PAY]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.DEPENDENCE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.LAST_ACTIVITY]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.CONTACT_NAME]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.CONVERTED_AMOUNT_DUE]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.CONVERTED_AMOUNT_TOTAL]: { filterType: FILTER_TYPE.NUMBER },
  [TABLE_COLUMN.DUE_DATE]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.INVOICE_NUMBER]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.ISSUE_DATE]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.EXPECTED_DATE]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.PDF_NAME]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.CREATED_BY]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.SAVED_ON]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.REPORT_NAME]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.NEXT_GENERATE_AT]: { filterType: FILTER_TYPE.DATE },
  [TABLE_COLUMN.PERIOD]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.SENDING_TO]: { filterType: FILTER_TYPE.TEXT },
  [TABLE_COLUMN.TIME]: { filterType: FILTER_TYPE.TIME },
  [TABLE_COLUMN.HELD_FOR_REVIEW]: { filterType: FILTER_TYPE.TIME },
  [TABLE_COLUMN.STATUS]: { filterType: FILTER_TYPE.SELECT }
};

export const initialFilterTableState: TableFiltersState = {
  filterAnchorElement: null,
  filters: { ...mockedInitialFilters }
};

export const mockedTableData: Data[] = [
  {
    id: '1',
    type: CUSTOMER_SUPPLIER_KIND.CUSTOMER,
    name: 'Customer 1',
    total_amount_due: 1000,
    total_amount_overdue: 1000,
    total_amount_invoiced: 1000,
    unpaid_invoices: 3,
    average_sale: 1000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 0, 3)
  },
  {
    id: '2',
    type: CUSTOMER_SUPPLIER_KIND.SUPPLIER,
    name: 'Customer 2',
    total_amount_due: 2000,
    total_amount_overdue: 2000,
    total_amount_invoiced: 2000,
    unpaid_invoices: 3,
    average_sale: 2000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 0, 13)
  },
  {
    id: '3',
    type: CUSTOMER_SUPPLIER_KIND.CUSTOMER,
    name: 'Customer 3',
    total_amount_due: 3000,
    total_amount_overdue: 3000,
    total_amount_invoiced: 3000,
    unpaid_invoices: 3,
    average_sale: 3000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 0, 21)
  },
  {
    id: '4',
    type: CUSTOMER_SUPPLIER_KIND.SUPPLIER,
    name: 'Customer 4',
    total_amount_due: 4000,
    total_amount_overdue: 4000,
    total_amount_invoiced: 4000,
    unpaid_invoices: 3,
    average_sale: 4000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 1, 10)
  },
  {
    id: '5',
    type: CUSTOMER_SUPPLIER_KIND.CUSTOMER,
    name: 'Customer 5',
    total_amount_due: 5000,
    total_amount_overdue: 5000,
    total_amount_invoiced: 5000,
    unpaid_invoices: 3,
    average_sale: 5000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 1, 15)
  },
  {
    id: '6',
    type: CUSTOMER_SUPPLIER_KIND.SUPPLIER,
    name: 'Customer 6',
    total_amount_due: 6000,
    total_amount_overdue: 6000,
    total_amount_invoiced: 6000,
    unpaid_invoices: 3,
    average_sale: 6000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 1, 26)
  },
  {
    id: '7',
    type: CUSTOMER_SUPPLIER_KIND.SUPPLIER,
    name: 'Customer 7',
    total_amount_due: 7000,
    total_amount_overdue: 7000,
    total_amount_invoiced: 7000,
    unpaid_invoices: 3,
    average_sale: 7000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 2, 4)
  },
  {
    id: '8',
    type: CUSTOMER_SUPPLIER_KIND.CUSTOMER,
    name: 'Customer 8',
    total_amount_due: 8000,
    total_amount_overdue: 8000,
    total_amount_invoiced: 8000,
    unpaid_invoices: 3,
    average_sale: 8000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 2, 5)
  },
  {
    id: '9',
    type: CUSTOMER_SUPPLIER_KIND.SUPPLIER,
    name: 'Customer 9',
    total_amount_due: 9000,
    total_amount_overdue: 9000,
    total_amount_invoiced: 9000,
    unpaid_invoices: 3,
    average_sale: 9000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 2, 6)
  },
  {
    id: '10',
    type: CUSTOMER_SUPPLIER_KIND.CUSTOMER,
    name: 'Customer 10',
    total_amount_due: 10000,
    total_amount_overdue: 10000,
    total_amount_invoiced: 10000,
    unpaid_invoices: 3,
    average_sale: 10000,
    average_days_to_pay: 45,
    dependence: 30,
    last_activity: new Date(2022, 2, 10)
  }
];
